
import { Box, Typography } from '@mui/material';
import '../styles/SectionCCard.scss';

interface SectionCCardProps {
  img: any;
  name: string;
  title: string;
  content: string;
}

const SectionCCard = ({ img, name, title, content }: SectionCCardProps) => {
  return (
    <Box className='section-c-card'>
      <Box className='image' component='img' src={img}></Box>
      <Box className='head1' />
      <Box className='head2' />
      <Box className='body'>
        <Typography component='h5'>{name}</Typography>
        <Typography component='h6' className='primary-color'>{title}</Typography>
        <Typography component='p'>{content}</Typography>
      </Box>
    </Box>
  );
};

export default SectionCCard;
